module.exports = __webpack_public_path__ + "static/media/005.b07d7c02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/005.jpg
// module id = 352
// module chunks = 0